/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_2Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_2_bullets_2 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make the data readable: format numbers consistently and use a chart when it helps answer a specific question, such as which category changed the most.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_2_bullets_2 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让数据易于阅读：统一数字格式，并在需要回答具体问题时使用图表，例如查看哪一类别变化最大。`)
};

/**
* | output |
* | --- |
* | "Make the data readable: format numbers consistently and use a chart when it helps answer a specific question, such as which category changed the most." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_2_bullets_2 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_2_bullets_2(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_2_bullets_2(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_2_bullets_2 as "gc.search_guides.what_is_gridcraft.sections.2.bullets.2" }